export default "__VITE_ASSET__BnLeNH0u__"